import { blendWithWhite, hexColorToRgba, rgbaToHexColor, stringToColor } from "./colors";

export const getUserProfileColor = (profile: string) => {
  const lowerName = profile.toLowerCase();
  if (lowerName.includes("visiteur")) {
    return "#CE7DF8";
  } else if (lowerName.includes("pmr")) {
    return "#66B8E9";
  } else if (lowerName.includes("résident") || lowerName.includes("resident")) {
    return "#6FB238";
  } else {
    // Generate color
    return stringToColor(profile);
  }
};

export const getUserProfileBackgroundColor = (profile: string) => {
  const mainColor = getUserProfileColor(profile);
  const rgba = hexColorToRgba(mainColor).slice(0, 3) as [number, number, number];
  const blendedRgba = blendWithWhite(rgba, 0.25);

  return rgbaToHexColor(blendedRgba);
};
